module.exports = __webpack_public_path__ + "static/media/costvLogo.ca5bed15.png";